import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';

import {RhynoApiProvider} from '../../providers/rhyno-api/rhyno-api';
import {LeistungProvider} from '../../providers/leistung/leistung';

/**
 * Generated class for the ExpenseItemDetailPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-expense-item-detail',
  templateUrl: 'expense-item-detail.html',
})
export class ExpenseItemDetailPage {
  expenseItem: any = {};
  loading: any;

  constructor(public navCtrl: NavController, 
  	public navParams: NavParams, 
  	private rhynoApi: RhynoApiProvider,
    public loadingCtrl: LoadingController,
  	public leistungCtrl: LeistungProvider) {

  	this.expenseItem = navParams.data.data;
	this.getData();

  }

  getData(){
  	this.loading = this.loadingCtrl.create({
      content: 'einen Moment...'
    });
    this.loading.present();

  	this.rhynoApi.getExpenseItem(this.expenseItem).subscribe(
      data => {
      if (data.success){
        this.expenseItem = data.data[0]; 
        console.log(data);
      }
      this.loading.dismiss();
    },
      err => {
      console.log(err);
      this.loading.dismiss();
    },
    () => console.log('Projekte Search Complete')
    );

  }
  doRefresh(refresher){
    this.getData();
    refresher.complete();
  }

  updateItem(item){
  	this.loading = this.loadingCtrl.create({
      content: 'einen Moment...'
    });
    this.loading.present();

    this.loading.dismiss();
    
  }
  
  ionViewDidLoad() {
    console.log('ionViewDidLoad ExpenseItemDetailPage');
  }
  deleteExpenseItem(){
    this.loading = this.loadingCtrl.create({
      content: 'einen Moment...'
    });
    this.loading.present();
    this.rhynoApi.deleteExpenseItem(this.expenseItem).subscribe(
      data => {
      this.loading.dismiss();
      this.navCtrl.pop();
    },
      err => {
      console.log(err);
      this.loading.dismiss();
    },
    () => console.log('Projekte Search Complete')
    );
  }

}



// WEBPACK FOOTER //
// ./src/pages/expense-item-detail/expense-item-detail.ts